import React, {useEffect} from "react";
import {Toaster} from "react-hot-toast";
import DeleteModal from "../../components/atoms/DeleteModal";
import InputGroup from "../../components/atoms/InputGroup";
import Loading from "../../components/atoms/Loading";
import TitleDetail from "../../components/atoms/TitleDetail";
import Navbar from "../../components/main/Navbar";
import DevicedetailHeadet from "../../components/deviceList/DevicedetailHeadet";
import {DeviceDetailUseContext} from "../../context/AdminDashboard/DeviceDetailContext";
import Inputguest from "../../components/deviceList/Inputguest";

const DeviceDetails = () => {
    const {
        Modelname,
        SerialNumber,
        ProductionDate,
        brokerPass,
        DateFirstConnection,
        lastStatus,
        name,
        phoneNumber,
        city,
        grantiNumber,
        grantiUsedStatus,
        puchaseDate,
        ActivatingUser,
        activationDate,
        guest,
        loaded,
        getdeviceDetail,
        grantiDeadTime,
        actionlog,
        onDeleteBroker,
        showDeleteModal,
        closeDeleteModal,
        RemoveItem,
        onDelete,
        showDeletebroker,
        closeDeleteBroker,
        RemoveBroker,
        pin,
        barcodeAddress
    } = DeviceDetailUseContext();

    // Extract query parameters from URL
    const urlParams = new URLSearchParams(window.location.search);

    // Fetch device details on component mount
    useEffect(() => {
        const id = urlParams.get("id");
        getdeviceDetail(id);
        document.title = "جزئیات دستگاه";
    }, []);

    return (
        <div className="pb-7.5px">
            <Navbar titles={["دستگاه‌ها", "فهرست دستگاه", "جزئیات دستگاه"]}/>
            {loaded ? (
                <>
                    <Loading height={"h-80"}/>
                </>
            ) : (
                <div
                    className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px"
                    dir="rtl">
                    <DevicedetailHeadet
                        text={"دستگاه"}
                        onDelete={onDelete}
                        onDeleteBroker={onDeleteBroker}
                        actionlog={actionlog}
                        name={SerialNumber}
                        barcodeAddress={barcodeAddress}
                    />
                    {/* General information */}
                    <TitleDetail title={"اطلاعات کلی"}/>
                    <div className="flex flex-row justify-between w-full gap-5 mt-25">
                        <InputGroup
                            iconName={"bubble"}
                            label="اسم مدل"
                            value={Modelname}
                            readOnly={true}
                        />
                        <InputGroup
                            iconName={"cpu"}
                            label="شماره سریال"
                            value={SerialNumber}
                            readOnly={true}
                        />
                        <InputGroup
                            iconName={"calendar"}
                            label="تاریخ ساخت"
                            value={ProductionDate}
                        />
                    </div>
                    <div className="flex flex-row justify-between w-full gap-5 mt-25">
                        <InputGroup
                            iconName={"password-check"}
                            label="رمز بروکر"
                            value={brokerPass}
                        />
                        <InputGroup iconName={"setting"} label="پین" value={pin}/>
                        <InputGroup
                            iconName={"calendar"}
                            label="تاریخ اولین اتصال"
                            value={DateFirstConnection}
                        />
                        <InputGroup
                            iconName={"cloud-connection"}
                            label="آخرین وضعیت"
                            value={lastStatus}
                        />
                    </div>
                    <TitleDetail title={"اطلاعات صاحب دستگاه"}/>
                    <div className="flex flex-row justify-between w-full gap-5 mt-25">
                        <InputGroup
                            iconName={"userF"}
                            label="نام و نام خانوادگی"
                            value={name}
                        />
                        <InputGroup
                            iconName={"call"}
                            label="شماره تلفن همراه"
                            value={phoneNumber.replace("+98", "0")}
                        />
                        <InputGroup iconName={"global"} label="استان و شهر" value={city}/>
                    </div>
                    <TitleDetail title={"اطلاعات گارانتی"}/>
                    <div className="flex flex-row justify-between w-full gap-5 mt-25">
                        <InputGroup
                            iconName={"barcode"}
                            label="شماره گارانتی"
                            value={grantiNumber}
                        />
                        <InputGroup
                            iconName={"calendar"}
                            label="تاریخ اتمام گارانتی"
                            value={grantiDeadTime}
                        />
                        <InputGroup
                            iconName={"box-2"}
                            label="آخرین استفاده از گارانتی"
                            value={grantiUsedStatus}
                        />
                    </div>
                    <TitleDetail title={"اطلاعات خرید"}/>
                    <div className="flex flex-row justify-between w-full gap-5 mt-25">
                        <InputGroup
                            iconName={"calendar"}
                            label="تاریخ خرید"
                            value={puchaseDate}
                        />
                        <InputGroup
                            iconName={"user-tick"}
                            label="کاربر فعال‌کننده"
                            value={ActivatingUser}
                        />
                        <InputGroup
                            iconName={"tick-circle"}
                            label="تاریخ فعال شدن دستگاه"
                            value={activationDate}
                        />
                    </div>
                    <TitleDetail title={"مهمان‌ها"}/>
                    <div className="flex flex-row justify-between w-full gap-5 mt-25">
                        <p className="w-1/2 text-dark-blue-200 text-12 leading-5">
                            نام و نام خانوادگی مهمان
                        </p>
                        <p className="w-1/2 text-dark-blue-200 text-12 leading-5">
                            شماره تلفن همراه مهمان
                        </p>
                    </div>
                    {guest.map((e, index) => {
                        return (
                            <div
                                className="flex flex-row justify-between w-full gap-5 mt-2.5"
                                key={index}>
                                <Inputguest iconName={"userF"} value={e.guestname}/>
                                <Inputguest
                                    iconName={"call"}
                                    value={e.guestNumber.replace("+98", "0")}
                                />
                            </div>
                        );
                    })}
                    {/* Render toaster for notifications */}
                    <Toaster/>
                    {/* Delete modals */}
                    <DeleteModal
                        text={`آیا برای حذف ${SerialNumber} مطمئن هستید؟`}
                        showDeleteModal={showDeleteModal}
                        closeDeleteModal={closeDeleteModal}
                        RemoveItem={RemoveItem}
                        title={"اخطار حذف دستگاه"}
                    />
                    <DeleteModal
                        text={`آیا برای اخراج ${SerialNumber} مطمئن هستید؟`}
                        showDeleteModal={showDeletebroker}
                        closeDeleteModal={closeDeleteBroker}
                        RemoveItem={RemoveBroker}
                        title={"اخطار اخراج از بروکر"}
                    />
                </div>
            )}
            {/* <Toaster/> */}
        </div>
    );
};

export default DeviceDetails;
